import { observable } from "mobx";
import { entities } from "sb-resp-lib";
import { Selection } from "../../contracts";
import { MarketTemplate, SelectionType, CardType } from "../../data";
import { selectionsOrdering, emptySelectionPointBox } from "../../constants";
import { findSelectionsOrdering, mapSelections } from "../../helpers";
import { isNumber } from "util";

/**
 * Order selections in markets for specific sport
 * @param selections
 * @param template
 */
export const fillEmptySelections = (selections: Selection[] | [], template: MarketTemplate, cardType: CardType): Selection[] => {
    let types = getSelectionTypes(selections);
    let type = pickSelectionType(types);
    let selectionType = findSelectionsType(selections);

    let orderIndex = findSelectionsOrdering(template, type);
    let order = selectionsOrdering[template][orderIndex];
    let selectionsSet: Selection[] = [];

    if (MarketTemplate[template] === MarketTemplate.ThreeBox) {
        selectionsSet = mapSelections(selections, order);
        selectionsSet = addPointsText(selectionsSet, cardType, selectionType);
        return observable.array(selectionsSet);
    }

    selectionsSet = getSelections(selections);
    let tempSet = selectionsSet.length ? selectionsSet : selections;

    if (MarketTemplate[template] === MarketTemplate.PointBox) {
        selectionsSet = [{ ...emptySelectionPointBox }, ...mapSelections(tempSet, order)];
        selectionsSet[0].points = getPoints(selections);
    }
    else {
        selectionsSet = mapSelections(tempSet, order);
    }

    selectionsSet = addPointsText(selectionsSet, cardType, selectionType);
    return observable.array(selectionsSet);
}

/**
 * Pick selection outcomeType to use for ordering find
 * @param types
 */
const pickSelectionType = (types: entities.OutcomeType[]): entities.OutcomeType => {
    return types.find(t => t === entities.OutcomeType.Draw || t === entities.OutcomeType.Tie) || types[0];
}

/**
 * Gather all selection outcomeTypes into array
 * @param selections
 */
const getSelectionTypes = (selections: Selection[]): entities.OutcomeType[] => {
    let result: entities.OutcomeType[] = [];
    selections.forEach(s => s.outcomeType && result.push(s.outcomeType));
    return result;
}

/**
 * Get selection for types HC or OU
 * @param selections
 */
const getSelections = (selections: Selection[]): Selection[] => {
    let selectionsSet: Selection[] = [];
    let type = findSelectionsType(selections);
    let mainLineSelections: Selection[] = [];

    type && (
        mainLineSelections = filterByMainPointLine(selections)
    );

    selectionsSet = mainLineSelections.length
        ? mainLineSelections
        : reduceSelections(selections)

    return selectionsSet;
}

/**
 * Find if selections are of type HC or OU
 * @param selections
 */
const findSelectionsType = (selections: Selection[]): SelectionType | undefined => {
    return (
        selections.find(s => s.outcomeType === "Over")
            ? SelectionType.OU
            : selections.find(s => s.outcomeType === "Home")
                ? SelectionType.HC
                : undefined
    )
}

/**
 * Get all selections with tag of "MainPointLine"
 * @param selections
 */
export const filterByMainPointLine = (selections: Selection[]): Selection[] => {
    if (selections.length === 2) {
        return selections;
    }

    return selections.filter(s => s && s.tags && s.tags.indexOf("MainPointLine") > -1);
}

/**
 * Reduce selections to show, in case of no MainPointLine selections
 * @param selections
 * @param type
 */
export const reduceSelections = (selections: Selection[]): Selection[] => {
    let reduced: Selection[] = [];
    let firstSelectionWithPoints = selections.find(s => isNumber(s.points));

    return !firstSelectionWithPoints
        ? reduced
        : pickSelectionsByPoints(firstSelectionWithPoints, selections)
}

/**
 * Use s1 points to find another selection with the same points
 * @param s1
 * @param selections
 */
const pickSelectionsByPoints = (s1: Selection, selections: Selection[]): Selection[] => {
    let reduced: Selection[] = [s1];
    let s2 = selections.find(
        s => isNumber(s.points)
            && s.id !== s1.id
            && Math.abs(s.points) === (s1.points && Math.abs(s1.points))
    );
    s2 && reduced.push(s2);

    return reduced;
}

/**
 * Get points to assign to pointsText
 * @param selections
 */
export const getPoints = (selections: Selection[]): number => {
    if (selections.length === 2) {
        return selections[0].points || 0;
    }

    let s = selections.find(s => s.points !== null && s.tags && s.tags.indexOf("MainPointLine") > -1) || selections.find(s => isNumber(s.points));
    return s && s.points ? s.points : 0;
}

/**
 * Assign points value to pointsText
 * @param selections
 */
const addPointsText = (selections: Selection[], cardType: CardType, selectionType?: SelectionType): Selection[] => {
	let checkType = cardType === CardType.American && selectionType === SelectionType.HC;
	selections.forEach((s) => {
		if (s.points === null || s.points === undefined) {
			s.pointsText = "";
			return s;	
		}
		let sign = checkType && s.points > 0 ? "+" : "";
		s.pointsText = `${sign}${s.points.toString()}`;
		return s;
	});
    return selections;
}
